export function ProductSoldBanner({ message }: { message: string }) {
  return (
    <div
      className='mx-auto mb-2 max-w-md rounded bg-zinc-400 px-6 py-6 text-center uppercase text-white'
      data-testid='sold-banner'
    >
      {message}
    </div>
  );
}
